import { MnoConfig } from '../types';

export const localhostConfig: MnoConfig = {
  id: 'berd_3',
  name: 'Life Local Development',
  colors: {
    primary: '#0A69AE',  // Life blue
    secondary: '#FDCD01', // MTN Yellow
  },
  countryCode: '234',
  phoneNumberMask: '000 000 0000',
  appUrl: 'http://localhost:8080',
  locations: [
    "New York",
    "London",
    "Tokyo",
    "Sydney",
    "Paris",
    "Berlin",
    "Toronto",
    "Mumbai",
  ],
};

